import React from "react";
import { cn } from "../../lib/utils";

const Button = React.forwardRef(
  ({ className, variant = "primary", size = "md", href, ...props }, ref) => {
  const variants = {
    primary: "bg-[#007AFF] text-white hover:bg-[#0062CC] active:scale-[0.98]",
    secondary: "bg-[#F2F2F7] text-[#1D1D1F] hover:bg-[#E5E5EA] active:scale-[0.98]",
    outline: "border border-[#007AFF] text-[#007AFF] hover:bg-[#007AFF]/5 active:scale-[0.98]",
    ghost: "text-[#007AFF] hover:bg-[#007AFF]/5 active:scale-[0.98]",
  };

  const sizes = {
    sm: "px-3 py-1.5 text-sm font-medium rounded-full",
    md: "px-5 py-2.5 text-[15px] font-semibold rounded-full",
    lg: "px-8 py-4 text-lg font-semibold rounded-full",
  };

  const Component = href ? "a" : "button";
  const componentProps = href
    ? { href, ...props }
    : { type: props.type ?? "button", ...props };

  return (
    <Component
      ref={ref}
      className={cn(
        "inline-flex items-center justify-center transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#007AFF] focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none",
        variants[variant],
        sizes[size],
        className
      )}
      {...componentProps}
    />
  );
  }
);

Button.displayName = "Button";

export { Button };
